import { axios, handleError } from '../axios';

export const getPreviousPosts = (categoryId, postGroup, postPlace, pageNumber, options = {}) => {
  return new Promise((resolve) => {
    // تنظیم پارامترهای درخواست
    const params = {
      c: categoryId,
      g: postGroup,
      p: postPlace,
      pn: pageNumber,
    };

    // تنظیمات axios
    const config = {
      params,
    };

    // اضافه کردن signal اگر وجود داشته باشد
    if (options.signal) {
      config.signal = options.signal;
    }

    axios
      .get('post/previous/', config)
      .then((response) => {
        try {
          resolve(response.data);
        } catch (e) {
          console.error(e.message);
        }
      })
      .catch((e) => {
        handleError(e);
      });
  });
};
